var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
import * as React from 'react';
import { BaseGauge } from './BaseGauge';
import { RadialGauge as KendoRadialGauge } from '@progress/kendo-charts';
import { Group } from '@progress/kendo-drawing';
import { classNames } from '@progress/kendo-react-common';
var RadialGauge = /** @class */ (function (_super) {
    __extends(RadialGauge, _super);
    function RadialGauge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getTarget = function () {
            return _this;
        };
        _this.deriveOptionsFromParent = function (options) {
            var _a = _this.props, pointer = _a.pointer, scale = _a.scale;
            return Object.assign({}, options, {
                pointer: pointer,
                scale: scale
            });
        };
        return _this;
    }
    Object.defineProperty(RadialGauge.prototype, "gaugeInstance", {
        /**
         * @hidden
         */
        get: function () {
            if (this._baseGauge !== null) {
                return this._baseGauge.gaugeInstance;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadialGauge.prototype, "surface", {
        /**
         * The Drawing `Surface` of the Gauge.
         */
        get: function () {
            if (this._baseGauge !== null) {
                return this._baseGauge.surface;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(RadialGauge.prototype, "element", {
        /**
         * The DOM element of the Gauge.
         */
        get: function () {
            if (this._baseGauge !== null) {
                return this._baseGauge.element;
            }
            return null;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     */
    RadialGauge.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, className = _a.className, baseGaugeProps = __rest(_a, ["children", "className"]);
        return (React.createElement(BaseGauge, __assign({}, baseGaugeProps, { deriveOptionsFromParent: this.deriveOptionsFromParent, ref: function (baseGauge) { return _this._baseGauge = baseGauge; }, gaugeConstructor: KendoRadialGauge, getTarget: this.getTarget, className: classNames('k-gauge', className) }), children));
    };
    /**
     * Exports a Gauge component as a Drawing `Scene`.
     *
     * @param {any} options - The parameters for the export operation.
     * @returns {Promise<Group>} - A promise that returns the root `Group` of the scene.
     */
    RadialGauge.prototype.exportVisual = function (options) {
        if (this.gaugeInstance !== null) {
            return Promise.resolve(this.gaugeInstance.exportVisual(options));
        }
        return Promise.resolve(new Group());
    };
    return RadialGauge;
}(React.Component));
export { RadialGauge };
